import {APIStatus} from '@web/core/constants'
import makeSlice from '@web/slices/common/sliceMaker'

import {fetchUseAllCoupon} from '../actions'

const slice = makeSlice({
    extraReducers(builder) {
        builder.addCase(fetchUseAllCoupon.pending, (state) => {
            state.scene = APIStatus.FETCHING
        })
        builder.addCase(fetchUseAllCoupon.fulfilled, (state) => {
            state.scene = APIStatus.RESOLVED
        })
        builder.addCase(fetchUseAllCoupon.rejected, (state) => {
            state.scene = APIStatus.REJECTED
        })
    },
})

export default slice.reducer
